<div class="offline-wrapper">
  <img src="/assets/images/logo-yova.png" alt="Logo yova" />
  <div class="offline--center">
    <h1>{{ 'PUBLIC.offline.title' | translate }}</h1>
    <p>{{ 'PUBLIC.offline.instructions' | translate }}</p>
    <ion-button mode="ios" expand="block" (click)="tryAgain()">{{ 'PUBLIC.offline.cta' | translate }}</ion-button>
  </div>
</div>
